import React__default from 'react';
import { CloseButton } from '@mantine/core';
import { ChevronIcon } from './ChevronIcon.js';

function SelectRightSection(_ref) {
  var shouldClear = _ref.shouldClear,
    clearButtonLabel = _ref.clearButtonLabel,
    onClear = _ref.onClear,
    size = _ref.size,
    error = _ref.error,
    clearButtonTabIndex = _ref.clearButtonTabIndex;
  return shouldClear ? ( /*#__PURE__*/React__default.createElement(CloseButton, {
    variant: "transparent",
    "aria-label": clearButtonLabel,
    onClick: onClear,
    size: size,
    tabIndex: clearButtonTabIndex,
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    }
  })) : ( /*#__PURE__*/React__default.createElement(ChevronIcon, {
    error: error,
    size: size
  }));
}

export { SelectRightSection };
//# sourceMappingURL=SelectRightSection.js.map
